import { render, staticRenderFns } from "./ModalCircular.vue?vue&type=template&id=8b349e24&"
import script from "./ModalCircular.vue?vue&type=script&lang=js&"
export * from "./ModalCircular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports